/* eslint-disable react/prop-types */
import React from 'react';

/**
 * KPI cards for the Subscription History detail (037) on the shared au-card system,
 * sourced from getSubscriptionHistorySummary (all_time + optional period with prior-
 * window deltas). Deltas are text + icon ("▲ N%" / "▼ N%" / "★ new" / "— 0%"), never
 * colour alone, and never NaN when the prior window is zero.
 *
 * Props: { summary: { all_time:{...}, period?:{...delta_*_pct} } }
 */
const n = (v) => (v == null ? '—' : Number(v).toLocaleString());

const Delta = ({ pct }) => {
  let icon; let cls; let text;
  if (pct == null) { icon = '★'; cls = 'au-delta--flat'; text = 'new'; }
  else if (pct > 0) { icon = '▲'; cls = 'au-delta--up'; text = `${Math.abs(pct)}%`; }
  else if (pct < 0) { icon = '▼'; cls = 'au-delta--down'; text = `${Math.abs(pct)}%`; }
  else { icon = '—'; cls = 'au-delta--flat'; text = '0%'; }
  return <span className={`au-delta ${cls}`} aria-label={`${icon} ${text} vs prior period`}>{icon} {text}</span>;
};

const Card = ({ label, value, delta }) => (
  <div className="au-card">
    <span className="au-card__label">{label}</span>
    <span className="au-card__value tnum">{value}</span>
    {delta !== undefined && <span className="sub-delta"><Delta pct={delta} /><span className="sub-delta__lbl">vs prior</span></span>}
  </div>
);

const SubscriptionHistorySummaryCards = ({ summary }) => {
  const all = (summary && summary.all_time) || {};
  const period = summary && summary.period;

  return (
    <>
      <div className="au-cards" data-testid="sub-history-summary">
        <Card label="Total Events" value={n(all.total_events)} />
        <Card label="Purchases" value={n(all.purchases)} />
        <Card label="Renewals" value={n(all.renewals)} />
        <Card label="Cancellations" value={n(all.cancellations)} />
        <Card label="Expired" value={n(all.expired)} />
      </div>

      {period && (
        <div className="au-panel" data-testid="sub-history-period">
          <div className="au-panel__head">
            <h4 className="au-panel__title">
              Selected period: {period.from_date} → {period.to_date}
              <span className="sub-delta__lbl"> (vs {period.prior_from_date} → {period.prior_to_date})</span>
            </h4>
          </div>
          <div className="au-cards">
            <Card label="Events" value={n(period.total_events)} delta={period.delta_total_events_pct} />
            <Card label="Purchases" value={n(period.purchases)} delta={period.delta_purchases_pct} />
            <Card label="Renewals" value={n(period.renewals)} delta={period.delta_renewals_pct} />
            <Card label="Cancellations" value={n(period.cancellations)} delta={period.delta_cancellations_pct} />
          </div>
        </div>
      )}
    </>
  );
};

export default SubscriptionHistorySummaryCards;
